import api from "../libs/api";

export default {
  searcGlobal: (params) => {
    // params should be a flat object: {q, page, sort_by, order_by, form_id, per_page}
    return new Promise((resolve, reject) => {
      api()
        .get("/global-search", {
          params: params,
        })
        .then(({ status, data }) => {
          if (status === 200 || status === 201) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },

  getAllForms: () => {
    return new Promise((resolve, reject) => {
      api()
        .get("/forms/?all")
        .then(({ status, data }) => {
          if (
            (status === 200 || status === 201) &&
            data &&
            Array.isArray(data.data)
          ) {
            resolve(
              data.data.map((form) => ({ id: form.id, name: form.name }))
            );
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },
};
